<template>
<div>
    <div class="ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
              <div class="investment__head">
                <FormSection title="Investment Term">
                	<div class="frequency">
                    <PaymentOptions addMonthly/>
                  </div>
                </FormSection>	
              </div>
                <FormSection title="Investment">
                    <div>
                        <AmountSelector/>                    
                        <ErrorLabel field="amount" />
                    </div>
                    <InHonorOf :recipent="false"/>
                </FormSection>
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                        <Consent privacy="https://www.ou.org/privacy-policy/"/>
                      </FormRow>
                    <br/>
                    <DonorAddress />
                    <FormRow>
                      <NewsletterSubscribe text="Yes, I would like to join the Accelerator mailing list" />
                    </FormRow>                    
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Donate Now"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}


::v-deep .ou-donation-form{
    h2{
      text-align: left;
      font-size: 17px;
    }


  label{
    font-size: 14px;
    color: black;
    font-weight: normal;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
    margin-bottom: 0px;
  }
  .investment__head{
    h2{
      text-align: center;
      margin: 13px 0px 0px;
      font-size: 17px;
    }
  }
  .styled-radio-container--ou-donation.styled-radio-container,
  .styled-radio--ou-donation.styled-radio{
    justify-content: center;
  }
  .styled-radio--ou-donation.styled-radio label{
    background: #dadada;
    line-height: 1.5;
    font-size: .875em;
  }

	  @media only screen and (min-width: 720px) {
      input[type=tel]{
        height: 42px;
        box-sizing: border-box;
        width: 100%;
        display: block;
        border: 1px solid #ddd;
        padding: 0 10px;
        border-radius: 4px;
        background: #f7f9fb;
        transition: all .3s ease-in-out;
        font-size: 16px;
        color: #222;            
      }

    }
.styled-radio.styled-radio--ou-donation.row{
  .radio-part{
	  @media only screen and (min-width: 720px) {
      min-width: 20%;
      max-width: 20%;
    }
  }
}
  .styled-radio-container--ou-donation.styled-radio-container .radio-part{

    input[type='radio']:checked + label{
      background: white;
      color: #575757;
          &:before{
             background: #15329d;
        }  
    }

    label{
      border: none;
        display: flex;
        flex-flow: column;
        justify-content: center;
            background: transparent;
        align-items: center;
        text-align: center;
        &:hover{
          background: none;
        }
        &:before{
          width: 80px;
          display: flex;
          height: 80px;
          flex-flow: column;
          margin: 0px auto 10px;
          background: #dadada;
          border-radius: 50%;
          justify-content: center;
          align-items: center;
        }
    }
    &:first-of-type{
        label{
            &:before{
              content: url("https://res.cloudinary.com/ouinternal/image/upload/c_scale,f_auto,q_auto,w_30/v1643018061/outorah/money-bill-alt-grey.png");
            }          
        }
        input[type='radio']:checked + label{
                &:before{
                  content: url("https://res.cloudinary.com/ouinternal/image/upload/c_scale,f_auto,q_auto,w_30/v1643018754/outorah/Shape__white.png");
                }   
        }
    }
    &:last-of-type{
        label{
            &:before{
              content: url("https://res.cloudinary.com/ouinternal/image/upload/c_scale,f_auto,q_auto,w_30/v1643018061/outorah/calendar-alt-grey.png");
            }          
        }
        input[type='radio']:checked + label{
                &:before{
                  content: url("https://res.cloudinary.com/ouinternal/image/upload/c_scale,f_auto,q_auto,w_30/v1643018754/outorah/calendar-alt-white.png");
                }   
        }        
    }

  }
 
}
</style>

